export const SET_THIRD_PARTY_ACCOUNTS = 'SET_THIRD_PARTY_ACCOUNTS'
export const SET_METRC_ACCOUNT = 'SET_METRC_ACCOUNT'
export const SET_METRC_FACILITIES = 'SET_METRC_FACILITIES'
export const SET_METRC_LOCATION_TYPES = 'SET_METRC_LOCATION_TYPES'
export const SET_METRC_FACILITIES_SEARCH = 'SET_METRC_FACILITIES_SEARCH'
export const SET_LINX_ACCOUNTS = 'SET_LINX_ACCOUNTS'
export const SET_QUICKBOOK_CONFIG = 'SET_QUICKBOOK_CONFIG'
export const SET_QUICKBOOK_OPERATIONS = 'SET_QUICKBOOK_OPERATIONS'
export const SET_QUICKBOOK_CATEGORIES = 'SET_QUICKBOOK_CATEGORIES'
export const SET_QUICKBOOK_ACCOUNT_DETAILS = 'SET_QUICKBOOK_ACCOUNT_DETAILS'
export const RESET = 'RESET'
export const SET_MTRAC_ACCOUNTS = 'SET_MTRAC_ACCOUNTS'
export const SET_CLOVER_ACCOUNTS = 'SET_CLOVER_ACCOUNTS'
export const SET_THIRD_PARTY_PRODUCTS = 'SET_THIRD_PARTY_PRODUCTS'
export const SET_THIRD_PARTY_BRANDS = 'SET_THIRD_PARTY_BRANDS'
export const SET_LEAFLY_ACCOUNTS = 'SET_LEAFLY_ACCOUNTS'
export const SET_LEAFLY_ACCOUNT = 'SET_LEAFLY_ACCOUNT'
export const SET_BIOTRACK_ACCOUNT = 'SET_BIOTRACK_ACCOUNT'
export const SET_UTAH_ICS_ACCOUNT = 'SET_UTAH_ICS_ACCOUNT'
export const SET_NM_CCD_ACCOUNT = 'SET_NM_CCD_ACCOUNT'



// WEBPACK FOOTER //
// ./src/types/thirdParty.js